import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

// Also set token in Authorization header as a fallback (cross-site cookies can be
// blocked; the login response sends back access_token which we keep in memory).
let accessToken = null;
export const setAccessToken = (token) => {
  accessToken = token;
  if (token) {
    localStorage.setItem("carmel_token", token);
  } else {
    localStorage.removeItem("carmel_token");
  }
};
export const loadStoredToken = () => {
  const t = localStorage.getItem("carmel_token");
  if (t) accessToken = t;
  return accessToken;
};

api.interceptors.request.use((config) => {
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }
  return config;
});

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Something went wrong.";
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  return String(d);
}
